import type { WidgetStaticProps } from '@swf/core/types/Widget';
import widgets from '@swf/widgets/index';

export const fetchProperties = async (type: keyof typeof widgets): Promise<WidgetStaticProps> =>
  widgets[type]
    ? ((await widgets[type].preload()) as unknown as { default: WidgetStaticProps }).default
    : {};
